import { IMenuGroup, IMenuList, IMultiLevelMenu } from '@interfaces/interfaces'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import StarIcon from '@mui/icons-material/Star'
import { Box, Menu, MenuItem, Typography } from '@mui/material'
import Button from '@mui/material/Button'
import Divider from '@mui/material/Divider'
import React, { useEffect, useState } from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom'

interface IMultiLevelNavigation {
  multiLevelMenu: IMultiLevelMenu
  highlightActive?: boolean
}

export const MultiLevelNavigation: React.FC<IMultiLevelNavigation> = ({
  multiLevelMenu,
  highlightActive,
}) => {
  const navigate = useNavigate()
  const location = useLocation()
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
  const [isActive, setIsActive] = useState(false)
  let open = Boolean(anchorEl)
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget)
  }
  const handleClose = () => {
    setAnchorEl(null)
  }
  const handleNavigate = (route: string) => {
    setAnchorEl(null)
    navigate(route)
  }

  useEffect(() => {
    setIsActive(Boolean(location.pathname === multiLevelMenu.route))
  }, [location.pathname, multiLevelMenu.route])

  if (!multiLevelMenu.isMenuList && multiLevelMenu.route) {
    if (highlightActive) {
      return (
        <Box>
          <Button
            onClick={() => {
              handleNavigate(multiLevelMenu.route as string)
            }}
            variant='text'
            color={isActive ? 'primary' : 'secondary'}
            disableElevation
            disableRipple
            type='button'
            sx={{
              fontWeight: 600,
              ':hover': { backgroundColor: 'transparent' },
              paddingY: 0,
            }}
          >
            {multiLevelMenu.heading}
          </Button>
          {isActive && (
            <Divider
              sx={{
                borderBottomWidth: 'medium',
                borderColor: 'primary.main',
              }}
            />
          )}
        </Box>
      )
    } else {
      return (
        <Button
          onClick={() => {
            handleNavigate(multiLevelMenu.route as string)
          }}
          variant='text'
          color='secondary'
          disableElevation
          disableRipple
          type='button'
          sx={{
            fontWeight: 600,
            ':hover': { backgroundColor: 'transparent' },
            paddingY: 0,
          }}
        >
          {multiLevelMenu.heading}
        </Button>
      )
    }
  }

  return (
    <>
      <Button
        aria-controls={open ? 'basic-menu' : ''}
        aria-haspopup='true'
        aria-expanded={open ? 'true' : 'false'}
        onClick={handleClick}
        variant='text'
        endIcon={multiLevelMenu.isDownArrow && <KeyboardArrowDownIcon />}
        color={open ? 'primary' : 'secondary'}
        disableElevation
        disableRipple
        type='button'
      >
        {multiLevelMenu.heading}
      </Button>
      <Menu
        id='menu-list'
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}
      >
        {multiLevelMenu.menuGroups?.length &&
          multiLevelMenu.menuGroups.map(
            (menuGroup: IMenuGroup, index: number) => {
              return (
                <div key={index}>
                  {menuGroup.groupName && (
                    <Typography variant='h6' px={2} fontWeight={400}>
                      {menuGroup.groupName}
                    </Typography>
                  )}
                  {menuGroup.menuList?.length &&
                    menuGroup.menuList.map(
                      (menuList: IMenuList, idx: number) => {
                        return (
                          <MenuItem key={idx}>
                            {menuList.icon && <StarIcon fontSize='inherit' />}
                            <Link
                              to={String(menuList.route)}
                              type='button'
                              color='secondary'
                              onClick={handleClose}
                              style={{
                                justifyContent: 'stretch',
                                textDecoration: 'none',
                                color: 'inherit',
                              }}
                            >
                              {menuList.page}
                            </Link>
                          </MenuItem>
                        )
                      },
                    )}
                </div>
              )
            },
          )}
        {multiLevelMenu.divider?.length && <Divider />}
        {multiLevelMenu.divider?.length &&
          multiLevelMenu.divider.map((menuList: IMenuList, index: number) => {
            return (
              <MenuItem key={index} sx={{ padding: 0 }}>
                <Button
                  type='button'
                  variant='text'
                  startIcon={menuList.icon}
                  href={menuList.route}
                  size='small'
                  color='secondary'
                  fullWidth
                  disableElevation
                  disableRipple
                  sx={{
                    justifyContent: 'stretch',
                    px: 4,
                    textDecoration: 'none',
                  }}
                >
                  {menuList.page}
                </Button>
              </MenuItem>
            )
          })}
      </Menu>
    </>
  )
}
